import { render, staticRenderFns } from "./ProjectActionsContainer.vue?vue&type=template&id=7a54850a&scoped=true&"
import script from "./ProjectActionsContainer.vue?vue&type=script&lang=js&"
export * from "./ProjectActionsContainer.vue?vue&type=script&lang=js&"
import style0 from "./ProjectActionsContainer.vue?vue&type=style&index=0&id=7a54850a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a54850a",
  null
  
)

export default component.exports